import { Table, Popconfirm, Col } from "antd";
import { ColumnProps } from "antd/lib/table";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Flex } from "@components/flex/flex";
import { TableComponentProps, TableData, TableHandlers } from "@components/table/tableContainer";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { TableIcon } from "@components/table/tableStyle";

export interface SocialFilterWordsTableData extends TableData {
    word: string;
}

export interface SocialFilterWordsTableProps extends TableComponentProps {
    dataSource: SocialFilterWordsTableData[];
    handlers: TableHandlers & {
        removeWord(word: string): void;
        updateWord(word: string): void;
    };
}

export class SocialFilterWordsTable extends React.Component<SocialFilterWordsTableProps> {
    public get socialFilterWordsColumns(): ColumnProps<SocialFilterWordsTableData>[] {
        return [
            {
                key: "word",
                title: <FormattedMessage id="word" />,
                dataIndex: "word"
            },
            {
                title: " ",
                key: "handlers",
                dataIndex: "",
                width: 120,
                render: (text, row, index) => {
                    const { handlers } = this.props;

                    return {
                        children: (
                            <Flex justifyContent="flex-end" alignItems="center">
                                <a onClick={() => handlers.updateWord(row.word)}>
                                    <TableIcon as={EditOutlined} />
                                </a>
                                <Popconfirm title={<FormattedMessage id="deleteConfirm" />} onConfirm={() => handlers.removeWord(row.word)} okText="Yes" cancelText="No">
                                    <TableIcon as={DeleteOutlined} />
                                </Popconfirm>
                            </Flex>
                        ),
                        props: {
                            colSpan: 2
                        }
                    };
                }
            }
        ];
    }

    public render() {
        return <Table pagination={{ showSizeChanger: true, showQuickJumper: true }} columns={this.socialFilterWordsColumns} rowKey="id" {...this.props} />;
    }
}
